import { useMutation } from '@tanstack/react-query';
import { uploadFileV2 } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { DataFileTct } from '@dealstack/shared/lib/generated';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { documentTemplateMutationError } from '@dealstack/frontend/app/pages/DocumentTemplates/api/documentTemplateMutationError';

// Uploads the STATIC_PDF source PDF via the generic /file endpoint; the returned
// fileId is what DOCUMENT_TEMPLATES_POST expects.
export const useUploadDocumentTemplateFile = () => {
	const tDefault = useTranslationDefault();

	return useMutation({
		mutationFn: async (file: File): Promise<DataFileTct> => {
			const response = await uploadFileV2(file);
			const payload = response.payload;
			if (payload == null) {
				throw new Error('File upload response missing payload');
			}
			return payload;
		},
		onError: (error: unknown) => documentTemplateMutationError(error, tDefault),
	});
};
